module.exports = __webpack_public_path__ + "static/img/线下活动-商业路演.b9b3718.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CPK10011/线下活动-商业路演.png
// module id = X+FP
// module chunks = 1